'use strict';

import get from 'lodash/get';
import {viewBreakpointLessThan} from '@/mixins/view-size';

const Magellan = window.Foundation.Magellan;

let isPdpInitDone = false;

const PdpLayoutHelper = {
  init: () => {
    const $menuItems = $('#inPage-menu-wrapper ul a');
    if (!$menuItems || !$menuItems.length) {
      return;
    }

    $menuItems.each(function() {
      const target = $(this).attr('href');
      if (!target || !target.length || target[0] !== '#') {
        return;
      }

      const targets = target.indexOf('|') < 0 ? new Array(target) : target.split('|');
      let canRemove = true;
      for (let targetItem of targets) {
        // Check whether the section exists
        if ($(targetItem).length) {
          canRemove = false;
          $(this).attr('href', targetItem);
          break;
        }
      }

      if (canRemove) {
        $(this)
          .parent()
          .hide();
      }
    });
  },
};

const PdpSubmenuNavigation = {
  scrollHeight: 0,

  update: () => {
    const $magellan = $('#secondary-nav [data-magellan-pdp]');
    if (
      $magellan &&
      $magellan.length > 0 &&
      document.documentElement.scrollHeight !== PdpSubmenuNavigation.scrollHeight
    ) {
      $magellan.foundation('reflow');
      PdpSubmenuNavigation.scrollHeight = document.documentElement.scrollHeight;
    }
  },

  initItemsNavigation: () => {
    $('[data-magellan-pdp] .menu-item a').on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      $('#secondary-nav').foundation('toggle');
      $('#secondary-nav [data-magellan-pdp]').foundation('scrollToLoc', $(this).attr('href'));
    });
  },

  stickNavigationContainer: () => {
    const $navContainer = $('#inPageNav');
    const offsetTop = 10;
    if (viewBreakpointLessThan('large')) {
      $('[data-pdp-container]').css('padding-top', $navContainer.height() + offsetTop);
    } else {
      $navContainer.addClass('mt-4');
    }
  },

  watchHeightChange: () => {
    setInterval(PdpSubmenuNavigation.update, 1500);
  },

  init: () => {
    if (!$('[data-magellan-pdp]').length) {
      return;
    }

    PdpSubmenuNavigation.initItemsNavigation();
    PdpSubmenuNavigation.watchHeightChange();
    PdpSubmenuNavigation.stickNavigationContainer();
    PdpSubmenuNavigation.update();
  },
};

/**
 * This function is a workaround for Magellan component to allow setting a different offset in mobile and desktop
 */
if ($('#secondary-nav [data-magellan-pdp]').length > 0) {
  const baseScrollToLoc = Magellan.prototype.scrollToLoc;
  Magellan.prototype.scrollToLoc = function(loc) {
    const offset = parseInt(
      viewBreakpointLessThan('large')
        ? this.options.offsetMobile ?? this.options.offsetDesktop
        : this.options.offsetDesktop
    );
    if (!isNaN(offset)) {
      this.options.offset = offset;
    }
    baseScrollToLoc.call(this, loc);
  };
}

$(function() {
  PdpLayoutHelper.init();
  PdpSubmenuNavigation.init();
});

export default function() {
  if (isPdpInitDone) {
    return;
  }
  isPdpInitDone = true;

  $(window).on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function() {
    $(window).trigger('resize');
  });

  const ReplacementSku = {
    $replacementEl: null,
    $noReplacementEl: null,
    $replacementButton: null,
    init: () => {
      ReplacementSku.$replacementEl = $(document).find('.replacement-sku');
      ReplacementSku.$replacementButton = $('#replacement-button');
      ReplacementSku.$noReplacementEl = $('#no-replacement-message');

      if (!ReplacementSku.$replacementEl.length) {
        return;
      }

      ReplacementSku.$replacementButton.on('click', function(e) {
        e.preventDefault();
        const contextPath = window.ACC.config.encodedContextPath || '';
        window.location.href = contextPath + $(this).data('replacementUrl');
      });

      ReplacementSku.displayBase();
    },
    displayVariant: (variant) => {
      if (!ReplacementSku.$replacementEl) {
        return;
      }

      ReplacementSku.toggleSection(false);

      const sku = get(variant, 'replacementProduct.sku');
      const url = get(variant, 'replacementProduct.url');

      if (!sku || !url) {
        ReplacementSku.displayBase();
      } else {
        ReplacementSku.toggleSection(true);
        ReplacementSku.setActiveReplacementId(sku, url);
      }
    },
    toggleSection: (show) => {
      if (!ReplacementSku.$replacementEl) {
        return;
      }

      ReplacementSku.$replacementEl[show ? 'show' : 'hide']();
      ReplacementSku.$noReplacementEl[!show ? 'show' : 'hide']();
      return show;
    },
    setActiveReplacementId(sku, url) {
      if (ReplacementSku.$replacementButton && ReplacementSku.$replacementButton.length > 0) {
        ReplacementSku.$replacementButton.data('replacementSku', sku || '');
        ReplacementSku.$replacementButton.data('replacementUrl', url || '');
      }
    },
    getBaseReplacementSku: () => {
      if (
        ReplacementSku.$replacementButton &&
        ReplacementSku.$replacementButton.data('baseReplacement') &&
        ReplacementSku.$replacementButton.data('baseReplacement').toString().length > 0
      ) {
        return ReplacementSku.$replacementButton.data('baseReplacement').toString();
      }
      return '';
    },
    displayBase: () => {
      if (!ReplacementSku.$replacementEl) {
        return;
      }

      let baseSku = ReplacementSku.getBaseReplacementSku();
      if (ReplacementSku.toggleSection(baseSku.length > 0)) {
        ReplacementSku.setActiveReplacementId(baseSku);
      } else {
        ReplacementSku.toggleSection(false);
      }
    },
  };

  let currentActiveElement = $('#secondary-nav .active').attr('href');
  $(document).on('update.zf.magellan', function(e, params) {
    if ($(params).attr('href') !== currentActiveElement) {
      currentActiveElement = $(params).attr('href');
      $('.contains-active').removeClass('contains-active');
      $(params)
        .parent()
        .addClass('contains-active');
    }

    const activeHref = $('#secondary-nav .active').attr('href');
    if (activeHref !== undefined && activeHref !== '#buying-zone' && activeHref !== '#overview') {
      $('#breadcrumbs-wrapper').addClass('hide');
      $('#breadcrumbs-displayName').removeClass('hide');
    } else {
      $('#breadcrumbs-wrapper').removeClass('hide');
      $('#breadcrumbs-displayName').addClass('hide');
    }
  });

  $(document).ready(function() {
    ReplacementSku.init();
  });
}
